// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Module/SDD/Page/Dashboard/index.scss
// module id = 8273
// module chunks = 2